export function trimEPStrailZero(value) {
    // console.log("trimEPStrailZero = ", value);
    value = parseFloat(value.toFixed(9));
    // console.log(value.toString());
    return value.toString();
  }